import { render, staticRenderFns } from "./CaseImagesSlider.vue?vue&type=template&id=da0b2946&"
import script from "./CaseImagesSlider.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CaseImagesSlider.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da0b2946')) {
      api.createRecord('da0b2946', component.options)
    } else {
      api.reload('da0b2946', component.options)
    }
    module.hot.accept("./CaseImagesSlider.vue?vue&type=template&id=da0b2946&", function () {
      api.rerender('da0b2946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorCases/components/CaseImagesSlider.vue"
export default component.exports